import React, { forwardRef, Fragment, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Modal as BSModal } from "bootstrap";

export default forwardRef(function Modal(props, ref) {

	useImperativeHandle(ref, () => ({
		show,
		close,
		setActions,
	}));

	const [showState, setShowState] = useState(false);
	const [actionsState, setActionsState] = useState(null);
	const modal = useRef(null);

	const show = (cb) => {
		setShowState(true);
		const modalEl = new BSModal(modal.current, {
			keyboard: false,
			backdrop: 'static',
			focus: false
		});
		modalEl.show();
		$(modal.current).on('hidden.bs.modal', () => {
			$(modal.current).off('hidden.bs.modal');
			$(modal.current).off('scroll');
			if (cb) cb();
		});
	};

	const close = (e) => {
		if (e) e.preventDefault();
		if (props.onClose && !props.onClose())
			return false;
		$(modal.current).modal('hide');
		setShowState(false);
		setActionsState(null)
	};

	useEffect(() => {
		return () => close();
	}, []);

	const setActions = (actions) => {
		setActionsState(actions);
	}

	return (
		<div className="modal fade" ref={modal}>
			<div className={"modal-dialog" + (props.wide ? ' modal-xl' : '') + (props.wider ? ' modal-lg' : '')} role="document">
				{showState && <div className="modal-content">
					<div className="modal-header">
						<h5 className="modal-title">{T(props.title)}</h5>
						<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div className="modal-body">
						{props.children}
					</div>
					{(props.submitForm || actionsState) && <div className="modal-footer bg-light">
						{actionsState && actionsState.map((action, i) => <Fragment key={i}>{action}</Fragment>)}
						{props.submitForm && <a href="#" onClick={(e) => {
							e.preventDefault();
							props.submitForm().submit();
						}} className="btn btn-secondary">{props.submitText ?? T('commonSave')}</a>}
					</div>}
				</div>}
			</div>
		</div>
	);
})